import React from "react";

function BLicon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"  {...props} >
      <symbol id="bl-icon" viewBox="0 0 36.52 42.005">
        <g fill="var(--secondary-text-color)">
          
          <path
            d="M10.4 289.724a2.783 2.783 0 00-.935 5.407v1.087h-.933v1.856h.928v2.921a3.836 3.836 0 01-2.823-2.918H4.753a5.692 5.692 0 0011.27 0h-1.881A3.836 3.836 0 0111.316 301v-2.921h.928v-1.855h-.928v-1.087a2.783 2.783 0 00-.92-5.407zm-.033 1.855a.928.928 0 11-.9.928.927.927 0 01.895-.928z"
            transform="translate(2 -291) translate(-1 25)"
          ></path>
          
          <path
            d="M1.587 289.063v42.005h25.03l11.491-9.441v-32.564zm1.826 1.5h32.869v30H25.326v9H3.414zm23.738 31.5h7.839l-7.839 6.44z"
            transform="translate(-1.588 -289.063)"
          ></path>
          
   
          <text 
            fontSize="21"
            fontWeight="700"
            transform="translate(-1 -286) translate(6 306)"
          >
            <tspan x="0" y="0">
              BL
            </tspan>
          </text>
          
        </g>
      </symbol>
      <use xlinkHref="#bl-icon"></use>
    </svg>
  );
}

export default BLicon;
